import { Box, Drawer, IconButton, List, ListItem, Stack, Tooltip, useTheme } from '@mui/material';
import { SlidersHorizontal, Play, Layers, BarChart2 } from 'lucide-react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '@/app/layout/Header';

const SIDENAV_WIDTH = 64;

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const menuItems = [
    { icon: SlidersHorizontal, label: 'Custom Prompts', path: '/admin' },
    { icon: Play, label: 'Trigger Extraction', path: '/admin/extract' },
    { icon: Layers, label: 'Projects', path: '/admin/projects' },
    { icon: BarChart2, label: 'AI Usage', path: '/admin/usage' },
  ];

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin' || location.pathname === '/admin/prompts';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Stack sx={{ height: '100%', overflow: 'hidden' }}>
      <Header />
      <Stack direction="row" sx={{ height: 'calc(100% - 64px)', mt: 0.5, gap: 0.5, overflow: 'hidden', px: 0.5, pb: 0.5 }}>
        {/* Collapsed Sidenav */}
        <Drawer
          variant="permanent"
          sx={{
            width: SIDENAV_WIDTH,
            flexShrink: 0,
            zIndex: 1,
            '& .MuiDrawer-paper': {
              width: SIDENAV_WIDTH,
              boxSizing: 'border-box',
              bgcolor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.2)' : '#fff',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1.5,
              position: 'relative',
              height: '100%',
              zIndex: 1,
            },
          }}
        >
          <List sx={{ pt: 2 }}>
            {menuItems.map((item) => (
              <ListItem key={item.path} disablePadding sx={{ display: 'block', mb: 1 }}>
                <Tooltip title={item.label} placement="right" arrow>
                  <IconButton
                    onClick={() => navigate(item.path)}
                    sx={{
                      width: 48,
                      height: 48,
                      mx: 'auto',
                      display: 'flex',
                      borderRadius: 1.5,
                      bgcolor: isActive(item.path) 
                        ? theme.palette.primary.main 
                        : 'transparent',
                      color: isActive(item.path) 
                        ? 'white' 
                        : 'text.secondary',
                      '&:hover': {
                        bgcolor: isActive(item.path)
                          ? theme.palette.primary.dark
                          : 'action.hover',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <item.icon size={22} />
                  </IconButton>
                </Tooltip>
              </ListItem>
            ))}
          </List>
        </Drawer>

        {/* Main Content Area */}
        <Box
          component="main"
          sx={{
            minWidth: 0,
            height: '100%',
            flex:1,
            overflow: 'auto',
            '& .MuiTableContainer-root': {
              borderRadius: 0,
            }
          }}
        >
          <Outlet />
        </Box>
      </Stack>
    </Stack>
  );
}
